<template>
  <div v-if="schemaComptable">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">{{ $t('detailSchemaComptable.title',
                { nomSchemaComptable: schemaComptable.libelle }) }}</h1>
              <app-breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="is-pulled-right buttons boutonAction">
            <a class="button is-addOrEdit"
               :class="{
                   'button-access-no-permission' : !checkPermissions(permsSchemaComptable.maj)
                   }"
               @click="$router.push({ name: 'm.parametrage.schema_comptable-edit',
               params: { id: $route.params.id } })">
              {{ $t('detailSchemaComptable.actions.edit') }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="columns is-multiline mgt-20px">
      <div class="column is-12">
        <div class="card">
          <header class="header-card">
            <p>
              {{$t('detailSchemaComptable.informationSchemaComptable.title')}}
            </p>
          </header>
          <div class="card-content">
            <div class="columns is-multiline">
              <p class="column is-12 is-size-4 has-text-weight-bold">
                {{ schemaComptable.libelle }}
              </p>
            </div>
            <div class="columns is-multiline">
              <b-field :label="$t('detailSchemaComptable.informationSchemaComptable.type')"
                       class="column is-2"
                       custom-class="has-text-default is-italic has-text-weight-light">
                    <span class="has-text-weight-bold">
                    {{ $t(getType) }}
                    </span>
              </b-field>
              <b-field :label="$t('detailSchemaComptable.informationSchemaComptable.compteNormal')"
                       class="column is-2"
                       custom-class="has-text-default is-italic has-text-weight-light">
                    <span class="has-text-weight-bold">
                    {{ schemaComptable.compteNormal }}
                    </span>
              </b-field>
              <b-field :label="
                $t('detailSchemaComptable.informationSchemaComptable.compteIntracommunautaire')"
                       class="column is-2"
                       custom-class="has-text-default is-italic has-text-weight-light">
                    <span class="has-text-weight-bold">
                    {{ schemaComptable.compteIntracommunautaire }}
                    </span>
              </b-field>
              <b-field :label="$t('detailSchemaComptable.informationSchemaComptable.compteExport')"
                       class="column is-2"
                       custom-class="has-text-default is-italic has-text-weight-light">
                  <b-tooltip class="width-100percent"
                  :label="$t('schemaComptableComponent.popUpSchemaComptable.compteTvaDebitToolTip'
                  )">
                    <span class="has-text-weight-bold">
                    {{ schemaComptable.compteExport }}
                    </span>
                  </b-tooltip>
              </b-field>
              <b-field :label="
                $t('detailSchemaComptable.informationSchemaComptable.produitConstate')"
                       class="column is-3"
                       custom-class="has-text-default is-italic has-text-weight-light">
                    <span class="has-text-weight-bold">
                    {{ schemaComptable.compteConstateDavance }}
                    </span>
              </b-field>
              <b-field
                :label="$t('detailSchemaComptable.informationSchemaComptable.compteTvaDebit')"
                       class="column is-2"
                       custom-class="has-text-default is-italic has-text-weight-light">
                <b-tooltip class="width-100percent"
                  :label="$t('schemaComptableComponent.popUpSchemaComptable.compteTvaDebitToolTip')
                  ">
                  <span class="has-text-weight-bold">
                    {{ schemaComptable.compteTva }}
                  </span>
                </b-tooltip>
              </b-field>
              <div class="column is-3 is-paddingless columns is-marginless">
                <b-field
                  :label="$t('detailSchemaComptable.informationSchemaComptable.tvaSurEncaissement')"
                        class="column is-narrow"
                        custom-class="has-text-default is-italic has-text-weight-light">
                    <span class="has-text-weight-bold">
                      {{ $t(`general.${schemaComptable.tvaSurEncaissement ? 'oui' : 'non'}`) }}
                    </span>
                </b-field>
                <b-field :label="
                  $t('detailSchemaComptable.informationSchemaComptable.compteTvaEncaissement')"
                        class="column"
                        custom-class="has-text-default is-italic has-text-weight-light">
                      <span class="has-text-weight-bold">
                      {{ schemaComptable.compteTvaEncaissement }}
                      </span>
                </b-field>
              </div>
              <b-field :label="
                $t('detailSchemaComptable.' +
                 'informationSchemaComptable.compteTvaDeductibleIntracommunautaire')"
                       class="column is-2"
                       custom-class="has-text-default is-italic has-text-weight-light">
                    <span class="has-text-weight-bold">
                    {{ schemaComptable.compteTvaDeductibleIntracommunautaire }}
                    </span>
              </b-field>
              <b-field v-if="priseEnCompteRemiseCompta" :label="
                $t('detailSchemaComptable.informationSchemaComptable.compteRemiseHorsRegie')"
                       class="column is-2"
                       custom-class="has-text-default is-italic has-text-weight-light">
                    <span class="has-text-weight-bold">
                    {{ schemaComptable.compteRemiseGeneral }}
                    </span>
              </b-field>
              <b-field v-if="priseEnCompteRemiseCompta" :label="
                $t('detailSchemaComptable.informationSchemaComptable.compteRemiseRegie')"
                       class="column is-2"
                       custom-class="has-text-default is-italic has-text-weight-light">
                    <span class="has-text-weight-bold">
                    {{ schemaComptable.compteRemiseRegie }}
                    </span>
              </b-field>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-12">
        <div class="card">
          <header class="header-card">
            <p>
              {{$t('detailSchemaComptable.parametrageLibelle.title')}}
            </p>
          </header>
          <div class="card-content">
            <div class="columns is-multiline">
              <b-field :label="$t('detailSchemaComptable.parametrageLibelle.ecriture')"
                       class="column is-3"
                       custom-class="has-text-default is-italic has-text-weight-light">
                <span class="has-text-weight-bold">
                  {{ schemaComptable.libelleEcriture }}
                </span>
              </b-field>
              <b-field :label="$t('detailSchemaComptable.parametrageLibelle.ecritureTiers')"
                       class="column is-3"
                       custom-class="has-text-default is-italic has-text-weight-light">
                <span class="has-text-weight-bold">
                  {{ schemaComptable.libelleLigneEcritureTiers }}
                </span>
              </b-field>
              <b-field :label="$t('detailSchemaComptable.parametrageLibelle.ecritureTva')"
                       class="column is-3"
                       custom-class="has-text-default is-italic has-text-weight-light">
                <span class="has-text-weight-bold">
                  {{ schemaComptable.libelleLigneEcritureTva }}
                </span>
              </b-field>
              <b-field
                :label="$t('detailSchemaComptable.parametrageLibelle.ecritureContrepartie')"
                       class="column is-3"
                       custom-class="has-text-default is-italic has-text-weight-light">
                <span class="has-text-weight-bold">
                  {{ schemaComptable.libelleLigneEcritureContrepartie }}
                </span>
              </b-field>
              <b-field v-if="schemaComptable.type === constantes.ACHAT"
                :label="$t('detailSchemaComptable.parametrageLibelle.referenceTiers')"
                       class="column is-3"
                       custom-class="has-text-default is-italic has-text-weight-light">
                <span class="has-text-weight-bold">
                  {{ schemaComptable.referenceLigneEcritureTiers }}
                </span>
              </b-field>
              <b-field v-if="schemaComptable.type === constantes.ACHAT"
                :label="$t('detailSchemaComptable.parametrageLibelle.referenceContrepartie')"
                       class="column is-3"
                       custom-class="has-text-default is-italic has-text-weight-light">
                <span class="has-text-weight-bold">
                  {{ schemaComptable.referenceLigneEcritureContrepartie }}
                </span>
              </b-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { get } from '@/api/schemaComptable/index';
import messageErreur from '@/services/general/messageErreur';
import breadcrumb from '@/components/general/breadcrumb';
import { SCHEMA_COMPTABLE } from '@/configuration/general/permissionsParametrageConf';
import { LISTE_TYPE_SCHEMA_COMPTABLE, ACHAT } from '@/configuration/parametrage/schemaComptableConf';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';

const permissions = createNamespacedHelpers('permissions');
const Parametres = createNamespacedHelpers('parametres');

export default {
  data() {
    return {
      schemaComptable: {},
      permsSchemaComptable: SCHEMA_COMPTABLE,
      listeTypeSchemaComptable: LISTE_TYPE_SCHEMA_COMPTABLE,
      constantes: {
        ACHAT,
      },
    };
  },
  components: {
    appBreadcrumb: breadcrumb,
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    breadcrumb() {
      return [
        { title: this.$t('parametrage.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('parametrage.title'), route: { name: 'l.parametrage.general' }, isActive: false },
        { title: this.$t('listeSchemaComptable.title'), route: { name: 'l.parametrage.schema_comptable' }, isActive: false },
        { title: this.$t('detailSchemaComptable.title', { nomSchemaComptable: this.schemaComptable.libelle }), route: { name: '' }, isActive: true },
      ];
    },
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    getType() {
      const type = this.listeTypeSchemaComptable.find((type) => {
        return type.code === this.schemaComptable.type;
      });
      if (!type) return '';
      return type.libelle;
    },
    priseEnCompteRemiseCompta() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.remiseComptabilisee.key);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.remiseComptabilisee.key]);
      this.schemaComptable = (await get(this.$route.params.id)).data.result;
      this.setInformationPage(this.$t('pageGeneral.detail', { item: this.schemaComptable.libelle }));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
